import { render, staticRenderFns } from "./OrganizationalUnitListItem.vue?vue&type=template&id=754640c4&"
import script from "./OrganizationalUnitListItem.vue?vue&type=script&lang=js&"
export * from "./OrganizationalUnitListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OrganizationalUnitListItem.vue"
export default component.exports